import React from 'react';

const ML_and_AI = () => {
    return (
        <div>ML_and_AI Component</div>
    );
}

export default ML_and_AI;
